var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","color":_vm.colorScoring,"icon":"AwardIcon","icon-right":"","statistic":_vm._f("fixNumber")(_vm.score),"statisticTitle":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }